"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateQueryParams = generateQueryParams;
exports.getParamsAsFormData = getParamsAsFormData;
exports.getParamsWithoutExistingFiles = getParamsWithoutExistingFiles;
exports.getDataWithRenamedProperty = getDataWithRenamedProperty;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _snakeCase = _interopRequireDefault(require("lodash/snakeCase"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Based on an object with key values, return the query string
 * @param {Object} params
 */
function generateQueryParams(params) {
  var url = '';

  if (typeof params === 'object') {
    Object.entries(params).filter(function (_ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
          value = _ref2[1];

      return !!value;
    }).forEach(function (_ref3, index) {
      var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      url += "".concat(index !== 0 ? '&' : '');

      if (Array.isArray(value)) {
        value.forEach(function (unit, ix) {
          url += "".concat(ix !== 0 ? '&' : '').concat(key, "[]=").concat(unit);
        });
      } else {
        url += "".concat(key, "=").concat(encodeURIComponent(value));
      }
    });
  }

  return url;
}

function appendToFormData(formData, data, key, toSnakeCase) {
  if (data instanceof File) {
    formData.append(key, data, data.name);
  } else if (data instanceof Array) {
    data.forEach(function (entry, index) {
      var nestedKey = (0, _isObject["default"])(entry) ? "".concat(key, "[").concat(index, "]") : "".concat(key, "[]");
      appendToFormData(formData, entry, nestedKey, toSnakeCase);
    });
  } else if (data === null) {
    formData.append(key, '');
  } else if ((0, _isObject["default"])(data)) {
    Object.entries(data).forEach(function (_ref5) {
      var _ref6 = (0, _slicedToArray2["default"])(_ref5, 2),
          prop = _ref6[0],
          value = _ref6[1];

      var nestedKey = key ? "".concat(key, "[").concat((0, _snakeCase["default"])(prop), "]") : (0, _snakeCase["default"])(prop);
      appendToFormData(formData, value, nestedKey, toSnakeCase);
    });
  } else {
    formData.append(key, data);
  }
}
/**
 * Return a FormData object with the params that are passed
 * Optionally, convert the keys to snake case
 * @param {Object} params
 * @param {Boolean} toSnakeCase
 */


function getParamsAsFormData(params) {
  var toSnakeCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!params) {
    throw new Error('No params were passed.');
  }

  var formData = new FormData();
  var entries = Object.entries(params);
  entries.forEach(function (_ref7) {
    var _ref8 = (0, _slicedToArray2["default"])(_ref7, 2),
        key = _ref8[0],
        value = _ref8[1];

    var formattedKey = toSnakeCase ? (0, _snakeCase["default"])(key) : key;
    appendToFormData(formData, value, formattedKey, toSnakeCase);
  });
  return formData;
}
/**
 * Checks if the "item" is a file-like Object, as returned
 * by our API (which includes a some properties that can be used
 * to get the file contents from the /files/<slug> endpoint)
 * @param {*} item
 */


function isExistingFile(item) {
  var existingFileProperties = ['insertedAt', 'uploadedByRole', 'slug', 'subType', 'type'];

  if ((0, _isObject["default"])(item)) {
    var keys = Object.keys(item);
    return existingFileProperties.every(function (property) {
      return keys.includes(property);
    });
  }

  return false;
}
/**
 * Removes properties of the "params" object if they are what
 * is returned by our API as a "file"
 * @param {Object} params
 */


function getParamsWithoutExistingFiles(params) {
  var result = {};
  Object.entries(params).forEach(function (_ref9) {
    var _ref10 = (0, _slicedToArray2["default"])(_ref9, 2),
        key = _ref10[0],
        value = _ref10[1];

    if (!isExistingFile(value)) {
      Object.assign(result, (0, _defineProperty2["default"])({}, key, value));
    }
  });
  return result;
}
/**
 * On some of the endpoints that return lists with pagination,
 * the list that is shown to the user comes as the value of a "data" key.
 * { data: ['red', 'green', 'blue', 'yellow'], page: 1, totalPages: 2 }
 * But others use a different key.
 * * { colors: ['red', 'green', 'blue', 'yellow'], page: 1, totalPages: 2 }
 * This helper receives an API response and allows for that key to be renamed,
 * returning an object with the list and pagination.
 * 🚨 Heads up! This is meant to be used with services that use the **makeServiceApi factory**
 * @param {Object} params
 */


function getDataWithRenamedProperty(APIResponse, propertyThatHasTheData) {
  var targetName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'data';

  if (!APIResponse) {
    throw new Error('No APIResponse was passed.');
  }

  if (!propertyThatHasTheData) {
    throw new Error('No propertyThatHasTheData was passed.');
  }

  var actualResponse = APIResponse.data;
  var result = (0, _cloneDeep["default"])(actualResponse);
  var mainData = actualResponse[propertyThatHasTheData];
  delete result[propertyThatHasTheData];
  return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2["default"])({}, targetName, mainData));
}